import Controller from "../product_lightbox_controller"
export default Controller